<!--地图组件-->
<template>
    <div id="cesiumContainer">
      <div id="popupInfo" style="position: absolute;width:auto;z-index: 100;"></div>
      <div class="filter-action">
        <img v-show="isAutoRotate==false" src="../img/play.png" @click="doRotateAroundPoint()">
        <img v-show="isAutoRotate==true" src="../img/pause.png" @click="doRotateAroundPoint()">
      </div>
      <layer-control v-if="isInitComplete"></layer-control>
      <floor-control v-if="isInitComplete&&floors.length" :floors="floors"/>
      <track-play-control v-if="isInitComplete&&isShowTrackPlayControl" ref="trackPlayControl" :tileSet="tileSet"/>
    </div>
</template>
<script>
import * as Cesium from 'cesium';
import $ from 'jquery';
import CesiumNavigation from 'cesium-navigation-es6';
import CONSTANTS from "./constants";
import Overlay from './Overlay.js';
import MapUtil from './utils/mapUtil';
import AroundPoint from './utils/AroundPoint';
import {AmapImageryProvider} from './AmapImageryProvider'
import * as Api from "@/api/api";
import LayerControl from "./layerControl";
import FloorControl from "./floorControl";
import {decrypt} from "./utils/crypto"
import TrackPlayControl from "./trackPlayControl";
import { getStorage,setStorage,removeStorage } from "@/utils/localStorage";
export default {
  name: 'Map',
  computed:{
  },
  components: {
    LayerControl,
    FloorControl,
    TrackPlayControl
  },
  data(){
    return {
      isInitComplete:false,//是否加载完成
      isAutoRotate:false,//是否自动旋转
      isShowTrackPlayControl:false,//是否显示轨迹播放工具
      initPosition:{longitude:118.0068086317,latitude:37.4909539775,height:500},//初始化位置,纬度wgs84
      mapConfig:null,
      floors:[],//楼层
      overLayers:[CONSTANTS.LAYER.WORKER,CONSTANTS.LAYER.ALARM],//Todo:点击冒泡图层
      tileSet:null
    }
  },
  mounted(){
    // let text="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";
    // console.log(decrypt(text));
    let self=this;
    this.$nextTick(() => {
      self.initViewer();
    })
    window.EventCenter.on('openTrack', (data) => {//打开轨迹
      console.log(data);
      //self.trackLayer.addEntities(data.path);
    });
    window.EventCenter.on('closeTrack', (data) => {//关闭轨迹
      //self.trackLayer.clearLayer();
    });
    let userInfo=JSON.parse(getStorage("userInfo"))
    if(userInfo&&userInfo.companyName){
      $.getJSON('http://file.tpy.aiweiyun.cn/tenants/'+userInfo.companyName+'/factoryAreas.json',(data)=>{
        setStorage("factoryAreas",JSON.stringify(data));
      })
    }

  },
  methods:{
    initViewer(){
      let self=this;
      //初始化viewer
      let viewer = new Cesium.Viewer('cesiumContainer',{
          shouldAnimate: true,//true ，否则为 false 。此选项优先于设置 Viewer＃clockViewModel 。
          animation: false, //是否创建动画小器件，左下角仪表
          baseLayerPicker: false, //是否显示图层选择器
          fullscreenButton: false, //是否显示全屏按钮
          geocoder: false, //是否显示geocoder小器件，右上角查询按钮
          homeButton: false, //是否显示Home按钮
          infoBox: false, //是否显示信息框
          selectionIndicator: false, //是否显示选取指示器组件
          timeline: false, //是否显示时间轴
          navigationHelpButton: false, //是否显示右上角的帮助按钮
          scene3DOnly: true, //如果设置为true，则所有几何图形以3D模式绘制以节约GPU资源
          clock: new Cesium.Clock(), //用于控制当前时间的时钟对象
          fullscreenElement: document.body, //全屏时渲染的HTML元素,
          useDefaultRenderLoop: true, //如果需要控制渲染循环，则设为true
          showRenderLoopErrors: false, //如果设为true，将在一个HTML面板中显示错误信息
          automaticallyTrackDataSourceClocks: true, //自动追踪最近添加的数据源的时钟设置
          sceneMode: Cesium.SceneMode.SCENE3D, //初始场景模式
          orderIndependentTranslucency: false,
          imageryProvider:new Cesium.WebMapTileServiceImageryProvider(CONSTANTS.TILE.tiandituImg),
          /*new AmapImageryProvider({//智图-蓝色
            url: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}',
            layer: 'tdtAnnoLayer',
            style: 'default',
            format: 'image/jpeg',
            maximumLevel: 18,
            subdomains: this.subdomains,
            tileMatrixSetID: 'GoogleMapsCompatible',
            crs: 'WGS84', // 坐标系: WGS84 、BD09 、GCJ02，仅百度、高德有效
            tilingScheme: null
          }),*/
          contextOptions: {
            webgl: {
              alpha: true,
            }
          },
      });
      //设置限制缩放大小
      viewer.scene.screenSpaceCameraController.maximumZoomDistance = 5000;
      viewer.scene.screenSpaceCameraController.minimumZoomDistance = 10;

      //修改天空盒
      //viewer.scene.skyBox.show = false;
      //viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0);
      viewer.scene.skyBox = new Cesium.SkyBox({
          sources : {
            positiveX :  '/static/imgs/map/skyBox/px_proc.png',
            negativeX :  '/static/imgs/map/skyBox/nx_proc.png',
            positiveY :  '/static/imgs/map/skyBox/pz_proc.png',
            negativeY :  '/static/imgs/map/skyBox/nz_proc.png',
            positiveZ :  '/static/imgs/map/skyBox/py_proc.png',
            negativeZ :  '/static/imgs/map/skyBox/ny_proc.png'
          }
        });
      //天地图
      viewer.imageryLayers.addImageryProvider(new Cesium.WebMapTileServiceImageryProvider(CONSTANTS.TILE.tiandituCia));

      // 隐藏球
      //viewer.scene.globe.show = false;
      //隐藏太阳
      viewer.scene.globe.enableLighting = false;
      viewer.shadows = false;
      viewer.scene.sun.show=false;//还可以viewer.scene.sun.destroy();
      //月亮
      viewer.scene.moon.show=false;
      //天空大气
      viewer.scene.skyAtmosphere.show=false;
      //雾
      viewer.scene.fog.enable=false;
      //相机不允许在地底移动
      viewer.scene.screenSpaceCameraController.enableCollisionDetection = true;
      // 关闭抗锯齿
      viewer.scene.postProcessStages.fxaa.enabled = false;
      viewer.scene.globe.enableLighting = false;  // 关闭光照效果

      let options = {};
      // 用于在使用重置导航重置地图视图时设置默认视图控制。接受的值是Cesium.Cartographic 和Cesium.Rectangle.
      options.defaultResetView = Cesium.Rectangle.fromDegrees(80, 22, 130, 50);
      // 罗盘,用于启用或禁用罗盘。true是启用罗盘，false是禁用罗盘。默认值为true。如果将选项设置为false，则罗盘将不会添加到地图中。
      options.enableCompass= true;
      // 缩放控件,用于启用或禁用缩放控件。true是启用，false是禁用。默认值为true。如果将选项设置为false，则缩放控件 将不会添加到地图中。
      options.enableZoomControls= true;
      // 距离图例,用于启用或禁用距离图例。true是启用，false是禁用。默认值为true。如果将选项设置为false，距离图例将不会添加到地图中。
      options.enableDistanceLegend= true;
      // 指南针外环,用于启用或禁用指南针外环。true是启用，false是禁用。默认值为true。如果将选项设置为false，则该环将可见但无效。
      options.enableCompassOuterRing= true;
      new CesiumNavigation(viewer, options);//主要方法

      window.viewer=viewer;
      document.getElementsByClassName('cesium-viewer-bottom')[0].style.display ='none';
      //viewer.scene.globe.depthTestAgainstTerrain = false;//解决地形遮挡entity问题

      //冒泡
      let overlay = new Overlay({ viewer: viewer, element: document.getElementById('popupInfo') });
      MapUtil.setOverlay(overlay);

      //事件
      let handler =new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      window.paths=[];
      //TODO 鼠标点击事件
      handler.setInputAction(function (movement) {
        let cartesian=viewer.camera.pickEllipsoid(movement.position,viewer.scene.globe.ellipsoid);
        let cartographic=Cesium.Cartographic.fromCartesian(cartesian);
        let lng=Cesium.Math.toDegrees(cartographic.longitude);//经度值
        let lat=Cesium.Math.toDegrees(cartographic.latitude);//纬度值
        let height=cartographic.height;//cartographic.height的值始终为零。

        let pick = viewer.scene.pick(movement.position);
        overlay.close();
        console.log([lng,lat,height],pick);
        window.paths.push([lng,lat]);
        if (pick&&pick.id&&pick.id.attributes) {
          window.EventCenter.emit('closeTrack', {});//关闭历史轨迹
          if(self.overLayers.indexOf(pick.id.attributes.layerName)>-1){
            MapUtil.openOverlay(pick.id);
          }

          // if(self.detailBoxLayers.indexOf(pick.id.attributes.layerName)>-1){
          //   window.EventCenter.emit('openDetail',pick.id.attributes);
          // }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
      //TODO 鼠标悬浮在实体
      handler.setInputAction(function(movement) {
        MapUtil.closeOverlay(); // 关闭冒泡
        if (viewer.scene.mode !== Cesium.SceneMode.MORPHING) {
          let pickedObject = viewer.scene.pick(movement.endPosition);
          if(Cesium.defined(pickedObject)) {
            if(Cesium.defined(pickedObject.id)&&Cesium.defined(pickedObject.id.attributes)&&self.overLayers.indexOf(pickedObject.id.attributes.layerName)>-1){
              MapUtil.openOverlay(pickedObject.id);
            }
          }
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);


      //加载用户模型
      Api.getModelList().then(res => {
        if (res.data.status_code === 100) {
          res.data.data.map((item) => {
            if(item.url.indexOf("mapConfig")>0){
              Api.getByUrl(item.url).then(function (res){
                if(res.data){
                  self.parseMapConfig({baseUrl:item.url.slice(0,item.url.lastIndexOf("/")),...res.data});
                }
              })
            }else{
              let coords=item.coor.split(",");
              self.loadModel({
                id:item.id,
                url:item.url,
                lng:Number(coords[0]),
                lat:Number(coords[1]),
                alt:Number(item.heading||0),
                show:true,
                height:item.scale
              });
            }
          })
        }
      });

      //TODO：监听打开轨迹播放工具
      this.EventCenter.on(CONSTANTS.EVENTS.TRACKPLAY, (obj) => {
        self.isShowTrackPlayControl=!self.isShowTrackPlayControl;
      });
      this.isInitComplete=true;//初始化完成
    },

    /**
     * 自动绕点旋转
     */
    doRotateAroundPoint(){
      if(!this.aroundPoint){
        this.aroundPoint = new AroundPoint(viewer, 0.2, new Cesium.Cartesian3.fromDegrees(this.initPosition.longitude, this.initPosition.latitude, 0));
      }
      this.initView();
      if(this.isAutoRotate==false){
        this.aroundPoint.start();
      }else{
        this.aroundPoint.stop();
      }
      this.isAutoRotate=!this.isAutoRotate;
    },


    initView(){
      //初始化相机
      window.viewer.flyTo(this.tileSet,{
        offset: new Cesium.HeadingPitchRange(Cesium.Math.toRadians(0), Cesium.Math.toRadians(-30.0), Number(this.initPosition.height||500)),
      });//飞行模型位置
    },

    /**
     * 解析地图模型配置
     * @param mapConfig
     */
    parseMapConfig(mapConfig){
      if(mapConfig.root){
        this.loadModel({
          id:mapConfig.root,
          show:true,
          url:mapConfig.baseUrl+"/"+mapConfig.root+"/tileset.json",
          ...mapConfig.position
        })
      }

      for (const [key, value] of Object.entries(mapConfig.floors)) {
        this.floors.push(key);
        this.loadModel({
          id:key,
          show:false,
          url:mapConfig.baseUrl+"/floors/"+key+"/tileset.json",
          ...value.position
        })
      }
    },

    /**
     * 加载模型
     * @param modelData
     */
    loadModel(modelData){
      let self=this;
      // modelData.lng=114.194560;
      // modelData.lat=35.853137;
      //modelData.alt=-4;
      console.log(modelData)
      window.viewer.scene.primitives.add( new Cesium.Cesium3DTileset({
        url: modelData.url,
        skipLevelOfDetail: true,
        baseScreenSpaceError: 1024,
        skipScreenSpaceErrorFactor: 2,
        skipLevels: 1,
        immediatelyLoadDesiredLevelOfDetail: false,
        loadSiblings: true, // 如果为true则不会在已加载完概况房屋后，自动从中心开始超清化房屋
        cullWithChildrenBounds: true,
        cullRequestsWhileMoving: true,
        cullRequestsWhileMovingMultiplier: 10, // 值越小能够更快的剔除
        preloadWhenHidden: true,
        preferLeaves: true,
        maximumMemoryUsage: 1024, // 内存分配变小有利于倾斜摄影数据回收，提升性能体验
        progressiveResolutionHeightFraction: 0.5, // 数值偏于0能够让初始加载变得模糊
        dynamicScreenSpaceErrorDensity: 0.5, // 数值加大，能让周边加载变快
        dynamicScreenSpaceErrorFactor: 1, // 不知道起了什么作用没，反正放着吧先
        dynamicScreenSpaceError: true, // 根据测试，有了这个后，会在真正的全屏加载完之后才清晰化房屋
        maximumNumberOfLoadedTiles: 10  // 最大加载的 tile 数量，数值加大，能让最终成像变模糊
      })).readyPromise.then(_tileset => {
        self.initPosition={longitude:modelData.lng,latitude:modelData.lat,height:Number(modelData.height||500)};
        _tileset.id = modelData.id;
        _tileset.show = modelData.show;
        _tileset.type='tileset';
        let cartographic = Cesium.Cartographic.fromCartesian(
          _tileset.boundingSphere.center
        );
        console.log("cartographic.height",cartographic.height)
        let longitude=modelData.lng||Cesium.Math.toDegrees(cartographic.longitude);
        let latitude=modelData.lat||Cesium.Math.toDegrees(cartographic.latitude);
        let height=modelData.alt||cartographic.height;
        window.viewer.tilesetModel={
          altitude:cartographic.height
        };
        //旋转角度设置
        let mx = Cesium.Matrix3.fromRotationX(Cesium.Math.toRadians(modelData.rotate?.rx||0));
        let my = Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(modelData.rotate?.ry||0));
        let mz = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(modelData.rotate?.rz||0));
        let rotationX = Cesium.Matrix4.fromRotationTranslation(mx);
        let rotationY = Cesium.Matrix4.fromRotationTranslation(my);
        let rotationZ = Cesium.Matrix4.fromRotationTranslation(mz);
        //平移 修改经纬度
        let position = Cesium.Cartesian3.fromDegrees(longitude,latitude,height);
        let transform = Cesium.Transforms.eastNorthUpToFixedFrame(position);
        //旋转、平移矩阵相乘
        Cesium.Matrix4.multiply(transform, rotationX, transform);
        Cesium.Matrix4.multiply(transform, rotationY, transform);
        Cesium.Matrix4.multiply(transform, rotationZ, transform);
        //缩放 修改缩放比例
        let scale = Cesium.Matrix4.fromUniformScale(1);
        Cesium.Matrix4.multiply(transform, scale, transform);
        //赋值给tileset
        _tileset._root.transform = transform;
        _tileset.show=true;
        self.tileSet=_tileset;
        //_tileset.style=new Cesium.Cesium3DTileStyle({color: "color('rgba(255,255,255,0.8)')"});//模型半透明
        //window.viewer.zoomTo(_tileset);//飞行模型位置
        //初始化相机
        self.initView();

      });
    }
  },
  beforeDestroy() {

    this.isInitComplete=false;
    window.EventCenter.removeListener('openTrack', () => { });//解除监听
    window.EventCenter.removeListener('closeTrack', () => { });//解除监听
    this.EventCenter.removeListener(CONSTANTS.EVENTS.TRACKPLAY, () => { });//解除监听
  }
}
</script>
<style scoped>
@import "map.css";
#cesiumContainer {
  width: 100%;
  height: 100vh;
}
/deep/ .cesium-widget canvas{
  height:100vh;
  width:100%;
}

/deep/ #navigationDiv{
  right: 26%;
  position: absolute;
  top: 0px;
}

.filter-action{
  width: 30px;
  height: 30px;
  position: absolute;
  top: 28%;
  right: 27.3%;
  z-index: 9;
  cursor: pointer;
}
</style>
